import {BaseService} from "@/core/services/BaseService";

class LogReportNotificationService extends BaseService<any> {
  endpoint = "/log-report-notification";

}

export default new LogReportNotificationService();